import { useTranslation } from 'react-i18next';
import { useMutation, useQueryClient } from 'react-query';
import { AxiosError } from 'axios';

import { QUERY_KEYS } from 'consts/queryKeys';
import { useCustomToast } from 'hooks';
import { stornInvoice } from 'modules/_common/api';

export const useMutationStornInvoice = () => {
  const { t } = useTranslation();
  const { successToast, errorToast } = useCustomToast();

  const queryClient = useQueryClient();

  return useMutation(stornInvoice, {
    onSuccess: () => {
      successToast(t('The invoice has been successfully storned'));
      queryClient.refetchQueries(QUERY_KEYS.RENTALS_ACCOMMODATION_INVOICES);
      queryClient.refetchQueries(QUERY_KEYS.INVOICES);
    },
    onError: (error: AxiosError) => {
      const errorMessage = error.response?.data as { ErrorDescription: string };
      errorToast(errorMessage?.ErrorDescription);
    },
  });
};
